/* src/app/admin/document-list/document-list.component.scss */
/*# sourceMappingURL=document-list.component-55SRG5VU.css.map */
